import type { InputHTMLAttributes } from 'react'
import type { UseFormRegisterReturn } from 'react-hook-form'
import { FormField } from '@/components/ui/form'

interface AuthTextFieldProps {
  id: string
  label: string
  type: 'text' | 'email' | 'password'
  autoComplete: InputHTMLAttributes<HTMLInputElement>['autoComplete']
  placeholder: string
  error?: string
  registration: UseFormRegisterReturn
}

export function AuthTextField({ id, label, type, autoComplete, placeholder, error, registration }: AuthTextFieldProps) {
  return (
    <FormField label={label} error={error}>
      <input
        id={id}
        type={type}
        autoComplete={autoComplete}
        placeholder={placeholder}
        {...registration}
        className={`input w-full ${error ? 'border-error-border' : ''}`}
      />
    </FormField>
  )
}
